<div class="modal-header">
  <div class="modal-header__title">
    <i
      *ngIf="icon"
      [class]="icon + ' modal-header__icon' + (iconClass ? ' ' + iconClass : '')"
    ></i>
    <div class="title-group">
      <span>{{ displayTitle }}</span>
      <span *ngIf="subtitle" class="modal-header__subtitle">{{ subtitle }}</span>
    </div>
  </div>
  <div class="modal-header__actions">
    <ng-content></ng-content>
    <button
      *ngIf="showClose"
      type="button"
      class="modal-header__close"
      (click)="close()"
      aria-label="Close modal"
    >
      <i class="pi pi-times"></i>
    </button>
  </div>
</div>
